export type FilterHistoryMode = 'COMPARE_TRANSACTIONS' | 'BENCHMARK_NEW_LAUNCH';

type ReferenceValue = {
  label?: string;
  latitude?: number;
  longitude?: number;
  radiusKm?: number;
} | null;

type FilterHistoryInput = {
  period?: string;
  customStart?: string;
  customEnd?: string;
  propertyType?: string;
  tenure?: string;
  saleTypes?: string[];
  excludeExecutiveCondominiums?: boolean;
  projects?: string[];
  districts?: string[];
  planAreas?: string[];
  regions?: string[];
  subtypes?: string[];
  nearestPriSch?: string[];
  nearestMrt?: string[];
  reference?: ReferenceValue;
  ranges?: Record<string, string>;
  dateFrom?: string;
  dateTo?: string;
};

const scalar = (value: unknown, defaultValue = ''): string => {
  if (value == null || value === '' || value === defaultValue) return '';
  return String(value);
};

const list = (value: unknown): string[] => Array.isArray(value)
  ? value.map(String).map((item) => item.trim()).filter(Boolean)
  : [];

const cleanRanges = (ranges: Record<string, string> = {}): Record<string, string> => Object.fromEntries(
  Object.entries(ranges)
    .map(([key, value]) => [key, String(value ?? '').trim()])
    .filter(([, value]) => value !== ''),
);

export function serializePsfFilterHistory(input: FilterHistoryInput): Record<string, unknown> {
  const reference = input.reference;
  return {
    period: input.period || '1Y',
    customStart: scalar(input.customStart),
    customEnd: scalar(input.customEnd),
    propertyType: scalar(input.propertyType, 'all'),
    tenure: scalar(input.tenure, 'all'),
    saleTypes: list(input.saleTypes),
    excludeExecutiveCondominiums: input.excludeExecutiveCondominiums ? 'true' : '',
    projects: list(input.projects),
    districts: list(input.districts),
    planAreas: list(input.planAreas),
    regions: list(input.regions),
    subtypes: list(input.subtypes),
    nearestPriSch: list(input.nearestPriSch),
    nearestMrt: list(input.nearestMrt),
    referenceProject: reference?.label || '',
    referenceRadius: reference?.radiusKm ?? '',
    referenceLatitude: reference?.latitude ?? '',
    referenceLongitude: reference?.longitude ?? '',
    ranges: cleanRanges(input.ranges),
    dateFrom: scalar(input.dateFrom),
    dateTo: scalar(input.dateTo),
  };
}
